jQuery(function ($) {
    console.log('wholesale js load')
    $(document).ready(function() {
    let $modal = $('#productImagesModal');
    let $thumbs = $('#modal-thumbs');
    let $big = $('#modal-bigimages');

    function openAt(i) {
        $modal.modal('show');
        $modal.one('shown.bs.modal', function () {
            setTimeout(function () {
                scrollTo(i);
                setActive(i);
            }, 80);
        });
    }

    function scrollTo(i) {
        let el = $big.find('[data-index="' + i + '"]').get(0);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    // Set active thumbnail
    function setActive(i) {
        $thumbs.find('.modal-thumb').removeClass('active');
        let t = $thumbs.find('[data-index="' + i + '"]').addClass('active');
        let el = t.get(0);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // Grid click 
    $('.grid-image-link').on('click', function (e) {
        e.preventDefault();
        let idx = $(this).data('index');
        openAt(idx);
    });

    // Show all
    $('#show-all-btn').on('click', function () {
        $modal.one('shown.bs.modal', function () { setTimeout(function(){ setActive(0); }, 80); });
    });

    // Thumbnail click
    $thumbs.on('click', '.modal-thumb', function () {
        let i = $(this).data('index');
        scrollTo(i);
        setActive(i);
    });

    var ticking = false;

  function handleScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function(){
      var containerTopInViewport = $big[0].getBoundingClientRect().top;
      var containerMiddleInViewport = containerTopInViewport + ($big.height() / 2);
      var closestIndex = null;
      var closestDistance = Infinity;

      $big.find('.big-image-wrap').each(function () {
        var el = this;
        var rect = el.getBoundingClientRect();
        var elMiddleInViewport = rect.top + (rect.height / 2);
        var distance = Math.abs(elMiddleInViewport - containerMiddleInViewport);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = $(el).data('index'); // keep same type as data-index
        }
      });

      if (closestIndex !== null && typeof setActive === 'function') {
        // normalize numeric index if possible
        var parsed = (closestIndex !== undefined && closestIndex !== null && !isNaN(parseInt(closestIndex,10))) ? parseInt(closestIndex,10) : closestIndex;
        setActive(parsed);
      }

      ticking = false;
    });
  }

  // attach the new handler
  $big.off('scroll.syncCenter').on('scroll.syncCenter', handleScroll);

  // initial check (center-based) - use same calculation approach
  function initialCenterCheck() {
    var containerTopInViewport = $big[0].getBoundingClientRect().top;
    var containerMiddleInViewport = containerTopInViewport + ($big.height() / 2);
    var chosen = null;

    $big.find('.big-image-wrap').each(function () {
      var rect = this.getBoundingClientRect();
      var elMiddleInViewport = rect.top + (rect.height / 2);

      if (elMiddleInViewport > (containerTopInViewport + $big.height() * 0.2) &&
          elMiddleInViewport < (containerTopInViewport + $big.height() * 0.6)) {
        chosen = $(this).data('index');
        return false; // break
      }
    });

    if (chosen !== null && typeof setActive === 'function') {
      var parsed = (chosen !== undefined && chosen !== null && !isNaN(parseInt(chosen,10))) ? parseInt(chosen,10) : chosen;
      setActive(parsed);
    }
  }

  setTimeout(initialCenterCheck, 60);

  setTimeout(handleScroll, 100);

    function addToCart() {
        $('#quantity').on('input', function(){
            this.value = this.value.replace(/[^0-9]/g, '');
            if (this.value === '' || this.value === '0') this.value = '1';
        });

         // Plus
        $('.qty-btn.plus').on('click', function(){
            let $qty = $('#quantity');
            let val = parseInt($qty.val()) || 1;
            $qty.val(val + 1).change();
        });

        // Minus
        $('.qty-btn.minus').on('click', function(){
            let $qty = $('#quantity');
            let val = parseInt($qty.val()) || 1;
            if(val > 1) $qty.val(val - 1).change();
        });

        $('.direct-checkout-btn').on('click', function () {
            let $btn = $(this);

            $btn.prop('disabled', true);
            $btn.addClass('loading'); 
            $btn.data('original-text', $btn.text());
            $btn.text('Adding...');

            let qty = parseInt($('#quantity').val()) || 1;
            let variantId = $btn.attr('data-variant-id');

            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: { id: variantId, quantity: qty },
                dataType: 'json',
                success: function(item) {
                    showCartNotification(item); 
                    updateCartBubbleFromServer(); 
                },
                error: function() {
                    alert("Something went wrong. Please try again.");
                },
                complete: function() {
                    $btn.prop('disabled', false);
                    $btn.removeClass('loading');
                    $btn.text($btn.data('original-text'));
                }
            });
        });
        }
        addToCart();

        function descExpand() {
            let fullText = $('.desc-full').text().trim();

            let words = fullText.split(/\s+/);
            let shortText = words.slice(0, 20).join(" ");

            if(words.length > 20){
                shortText += " ...";
            }

            $('.desc-short').text(shortText);

            $('.desc-toggle').on('click', function(){
                let full = $('.desc-full');
                let short = $('.desc-short');
                let chevron = $(this).find('.chevron');

                if(full.is(':visible')){
                    full.slideUp(250, function(){
                        short.show();
                    });
                } else {
                    short.hide();
                    full.slideDown(250);
                }

                chevron.toggleClass('rotate');
            });
        }
        descExpand()

        function buildNotificationHtml(item){
            let imgUrl = item.image ? item.image.replace(/(\.jpg|\.png|\.gif)(?:\?.*)?$/i, '_compact$1') : '';
            let html = '<div class="cart-notification-item" style="display:flex;align-items:center;">';
            if(imgUrl){
            html += '<div style="width:64px;height:64px;margin-right:12px;"><img src="'+imgUrl+'" alt="'+escapeHtml(item.title)+'" style="width:100%;height:100%;object-fit:cover;border-radius:4px;"></div>';
            }
            html += '<div style="flex:1">';
            html += '<div style="font-weight:600;">' + escapeHtml(item.title) + '</div>';
            if(item.variant_title) html += '<div style="font-size:13px;color:#666;margin-top:3px;">' + escapeHtml(item.variant_title) + '</div>';
            html += '<div style="font-size:13px;color:#000;margin-top:6px;" class="quantity-text">Quantity: <span>' + (item.quantity||1) + '</span></div>';
            html += '</div>';
            html += '</div>';
            return html;
        }

        function escapeHtml(text){
            return (text || '').replace(/[&<>"'`]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;','`':'&#96;'}[ch]; });
        }

        function showCartNotification(item){
            $.getJSON('/cart.js').done(function(cart){
            updateCartCountUI(cart.item_count || 0);
            let html = buildNotificationHtml(item);
            $('#cart-notification-product').html(html);


            let $notif = $('#cart-notification');
            if(!$notif.length) return;

            if($notif.hasClass('is-hidden') || $notif.hasClass('hidden')) {
                $notif.removeClass('is-hidden hidden');
            }

            $notif.css({
                'transform': 'translateY(0)',
                'visibility': 'visible',
                'transition': 'transform 300ms ease, visibility 300ms'
            });

            $notif.attr('aria-hidden', 'false');
            $notif.focus();

            }).fail(function(){
            $('#cart-notification-product').html(buildNotificationHtml(item));
            let $notif = $('#cart-notification');
            $notif.css({ 'transform': 'translateY(0)', 'visibility': 'visible', 'transition': 'transform 300ms ease' });
            $notif.attr('aria-hidden','false').focus();
            });
        }

        function updateCartCountUI(count){
            let selectors = ['.cart-count', '.site-header__cart-count', '[data-cart-count]', '.js-cart-count', '.cart-badge', '.header-cart-count'];
            selectors.forEach(function(sel){
            $(sel).each(function(){ $(this).text(count); });
            });
            $('[data-cart-count]').attr('data-cart-count', count);
            try{ $(document).trigger('cart:updated', { item_count: count }); }catch(e){}
        }

        $(document).on('click', '#cart-notification .cart-notification__close, #cart-notification .button-label', function(e){
            e.preventDefault();
            hideCartNotification();
        });

        function hideCartNotification(){
            let $notif = $('#cart-notification');
            if(!$notif.length) return;
            $notif.css({ 'transform': 'translateY(-100%)', 'visibility': 'hidden' });
            $notif.attr('aria-hidden','true');
        }

        function updateCartBubbleFromServer() {
        $.getJSON('/cart.js').done(function(cart){
            updateCartBubble(cart.item_count || 0);
        }).fail(function(){
            console.warn('Unable to fetch cart.js to update badge.');
        });
        }

        function updateCartBubble(count) {
            const $icon = $('#cart-icon-bubble');

            if (!$icon.length) return;

            let $bubble = $icon.find('.cart-count-bubble');

            if (!$bubble.length) {
                $bubble = $(`
                <div class="cart-count-bubble">
                    <span aria-hidden="true"></span>
                    <span class="visually-hidden"></span>
                </div>
                `);
                $icon.append($bubble);
            }

            $bubble.find('span[aria-hidden="true"]').text(count);
            $bubble.find('.visually-hidden').text(count + (count === 1 ? " item" : " items"));

            if (count > 0) {
                $bubble.show();
                $bubble.addClass('cart-bubble-update');
                setTimeout(() => $bubble.removeClass('cart-bubble-update'), 600);
            } else {
                $bubble.hide();
            }
        }

         $('#loginModal').on('show.bs.modal', function (event) {
            let button = $(event.relatedTarget) 
            let url = button.data('img') 
            let modal = $(this)
            modal.find('.login-banner').attr('src', url)
        })

    })



});

document.addEventListener("DOMContentLoaded", function () {
const params = new URLSearchParams(window.location.search);
const submitStatus = params.get("email_submit");

if (submitStatus === "success") {
    localStorage.setItem("natpat_email_submit", "success");
}
const stored = localStorage.getItem("natpat_email_submit");
console.log(stored)
if (stored === "success") {
    document.body.classList.add("natpat_email_submit");
} else {
    document.body.classList.remove("natpat_email_submit");
}
});